import ajax from './ajax';
import qs from 'qs';

class GraphService{

    async getMeasureDataEveryday(from_date, from_to){
        let params ={from_date:from_date, to_date:from_to};
        let url = process.env.REACT_APP_API_CONNECT_SERVICE_BASE_URL + "health_service/userinfo/appGraph";
        // data = qs.stringify(data);
        try{
            const response = await ajax.formPost(url, params);
            console.group("getMeasureDataEveryday");
            console.log(url, params, response);
            console.groupEnd();
            return response.data.result;
        }catch(error){
            console.log(error);
            return error;
        }
    }

    // async getMeasureDataEveryday(measureDateFrom, measureDateTo){
    //     let params ={measureDateFrom:measureDateFrom, measureDateTo:measureDateTo};
    //     let url = process.env.REACT_APP_API_CONNECT_SERVICE_BASE_URL + "connect_service/v2/measuredata/findScope";
    //     // data = qs.stringify(data);
    //     try{
    //         const response = await ajax.formPost(url, params);
    //         console.group("getMeasureDataEveryday");
    //         console.log(url, params, response);
    //         console.groupEnd();
    //         return response.data.result;
    //     }catch(error){
    //         console.log(error);
    //         return error;
    //     }
    // }

    // async getMedication(fromDate, toDate){
    //     let params ={from_date:fromDate, to_date:toDate};
    //     let url = process.env.REACT_APP_API_ACCOUNT_SERVICE_BASE_URL + "user_medication/find_scope";

    //     try{
    //         const response = await ajax.formPost(url, params);
    //         console.group("getMedication");
    //         console.log(url, params, response);
    //         console.groupEnd();
    //         return response.data;
    //     }catch(error){
    //         console.log(error);
    //         return null;
    //     }
    // }

    // async getCondition(fromDate, toDate){
    //     let params ={from_date:fromDate, to_date:toDate};
    //     let url = process.env.REACT_APP_API_ACCOUNT_SERVICE_BASE_URL + "user_condition/find_scope";

    //     try{
    //         const response = await ajax.formPost(url, params);
    //         console.group("getCondition");
    //         console.log(url, params, response);
    //         console.groupEnd();
    //         return response.data.result;
    //     }catch(error){
    //         console.log(error);
    //         return null;
    //     }
    // }

    // async getMEWC(){
    //     let params ={};
    //     let url = process.env.REACT_APP_API_ACCOUNT_SERVICE_BASE_URL + "user/mewc/program/current_list";

    //     try{
    //         const response = await ajax.formPost(url, params);
    //         console.group("getMEWC");
    //         console.log(url, params, response);
    //         console.groupEnd();
    //         return response.data.result;
    //     }catch(error){
    //         console.log(error);
    //         return null;
    //     }
    // }

    // async getGoalSysDia(){
    //     const token = sessionStorage.getItem('accessToken');
    //     let url = process.env.REACT_APP_API_HEALTH_SERVICE_BASE_URL + "userinfo/findByUserId";

    //     try{
    //         const response = await ajax.formGet(url);
    //         console.group("getGoalSysDia");
    //         console.log(url, response);
    //         console.groupEnd();
    //         return response.data.result;
    //     }catch(error){
    //         console.log(error);
    //         return null;
    //     }
    // }

    // async getStep(fromDate, toDate){
    //     let params ={from_date:fromDate, to_date:toDate};
    //     let url = process.env.REACT_APP_API_ACCOUNT_SERVICE_BASE_URL + "step/detail/findScope";

    //     try{
    //         const response = await ajax.formPost(url, params);
    //         console.group("getStep");
    //         console.log(url, params, response);
    //         console.groupEnd();
    //         return response.data;
    //     }catch(error){
    //         console.log(error);
    //         return null;
    //     }
    // }

    // async getSleep(fromDate, toDate){
    //     let params ={from_date:fromDate, to_date:toDate};
    //     let url = process.env.REACT_APP_API_ACCOUNT_SERVICE_BASE_URL + "sleep/detail/findScope";

    //     try{
    //         const response = await ajax.formPost(url, params);
    //         console.group("getSleep");
    //         console.log(url, params, response);
    //         console.groupEnd();
    //         return response.data;
    //     }catch(error){
    //         console.log(error);
    //         return null;
    //     }
    // }

    // async getTemperatureData(fromDate, toDate){
    //     let params = { from_date: fromDate, to_date: toDate };
    //     let url = process.env.REACT_APP_API_HEALTH_SERVICE_BASE_URL + "user/temperature/findScope";

    //     try {
    //         const response = await ajax.formPost(url, params);
    //         console.group("getTemperatureData");
    //         console.log(url, params, response);
    //         console.groupEnd();
    //         return response.data;
    //     } catch (error) {
    //         console.log(error);
    //         return null;
    //     }
    // }

    // async getBloodGlucose(fromDate, toDate) {
    //     let params = { from_date: fromDate, to_date: toDate };
    //     let url = process.env.REACT_APP_API_HEALTH_SERVICE_BASE_URL + "userbloodglucose/findScope";

    //     try {
    //         const response = await ajax.formPost(url, params);
    //         console.group("getBloodGlucose");
    //         console.log(url, params, response);
    //         console.groupEnd();
    //         return response.data;
    //     } catch (error) {
    //         console.log(error);
    //         return null;
    //     }
    // }

    // async getSpo2(fromDate, toDate) {
    //     let params = { from_date: fromDate, to_date: toDate };
    //     let url = process.env.REACT_APP_API_HEALTH_SERVICE_BASE_URL + "user/spo2/findScope";

    //     try {
    //         const response = await ajax.formPost(url, params);
    //         console.group("getspo2");
    //         console.log(url, params, response);
    //         console.groupEnd();
    //         return response.data;
    //     } catch (error) {
    //         console.log(error);
    //         return null;
    //     }
    // }

    // async getGoal() {
    //     let params = {}
    //     let url = process.env.REACT_APP_API_HEALTH_SERVICE_BASE_URL + "system/usergoal/info";

    //     try {
    //         const response = await ajax.formPost(url, params);
    //         console.group("getGoal");
    //         console.log(url, params, response);
    //         console.groupEnd();
    //         return response.data;
    //     } catch (error) {
    //         console.log(error);
    //         return null;
    //     }
    // }

    // async test(fromDate, toDate){
    //     let data ={from_date:fromDate, to_date:toDate};
    //     let url = "http://192.168.0.110/omron-AccountService/public/index.php/user_condition/find_scope";
    //     console.log("================================================");
    //     console.log(url, data);
    //     console.log("================================================");

    //     return ajax.post(url, data);
    // }

}

export default new GraphService();



// WEBPACK FOOTER //
// ./src/api/graphService.jsx